<template>
  <div class="invoice">
    <div class="t-nav">
      <nav>
        <ul class="r-nav">
          <li class="active"><a href="javascript:;">发票列表</a></li>
          <li class=""><router-link to="/home/getinvoice">发票索取</router-link></li>
          <li class=""><router-link to="/home/managerinvoice">发票信息管理</router-link></li>
        </ul>
      </nav>
    </div>
    <div class="search">
      <span>搜索开票月份:</span>
      <el-date-picker
        v-model="invoicetime"
        value-format="yyyy-MM-dd"
        type="daterange"
        align="right"
        unlink-panels
        size="small"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions">
      </el-date-picker>
      <span>发票状态:</span>
      <el-select v-model="value" placeholder="全部" size="small" class="sel">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <el-input v-model="input" placeholder="订单编号" size="small"></el-input>
      <span class="btn-srarch" @click="applyInvoiceList">检索</span>
    </div>
    <el-table
      :data="tableData"
      stripe
      style="width: 100%"
      class="detail">
      <el-table-column
        prop="applyTime"
        label="申请时间"
        width="180">
      </el-table-column>
      <el-table-column
        label="发票抬头"
        width="240"
        align="center">
        <template slot-scope="scope">
          <a href="#">{{ scope.row.org_name }}</a>
        </template>
      </el-table-column>
      <el-table-column
        prop="amount"
        label="发票总额"
        align="center"
        >
      </el-table-column>
      <el-table-column
        label="发票性质"
        align="center"
        >
        <template slot-scope="scope">
          <a href="#" v-html="scope.row.invoiceType" @click="download(scope.row.id)"></a>
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="发票状态"
        align="center"
        >
      </el-table-column>
    </el-table>
    <div class="pages" v-if="total>pageSize">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="pageSize"
        background
        layout="sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import eventBus from '../../common/eventBus.js'
export default {
  name: 'Invoice',
  components: {
  },
  created () {
    this.applyInvoiceList()
  },
  data () {
    return {
      currentPage: 1,
      pageSize: 5,
      total: 0,
      input: '',
      value: '',
      invoicetime: '',
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      options: [{
        value: '',
        label: '全部'
      }, {
        value: '开票中',
        label: '开票中'
      }, {
        value: '已开票',
        label: '已开票'
      }
      ],
      tableData: []
    }
  },
  methods: {
    applyInvoiceList() {
      var startDate = ''
      var endDate = ''
      if (this.invoicetime) {
        startDate = this.invoicetime[0]
        endDate = this.invoicetime[1]
      }
      let queryParam = {
        code: this.input,
        status: this.value,
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        startDate: startDate,
        endDate: endDate
      }
      this.sapost('/dmc/account/applyInvoiceList', queryParam, r => {
        let { retMsg, retCode, pager } = r.data
        if (retCode === '0') {
          this.total = pager.total
          this.tableData = pager.list
        } else {
          if (retMsg === '用户未登录！') {
            eventBus.$emit('logout')
          }
          this.$message.warning(retMsg)
        }
      })
    },
    handleSizeChange (val) {
      console.log('当前页数发生改变')
      this.pageSize = val
      this.applyInvoiceList()
    },
    handleCurrentChange (val) {
      console.log('当前页码发生改变')
      this.currentPage = val
      this.applyInvoiceList()
    }
  }
}
</script>

<style lang="less">
.invoice{
  margin-left: 200px;
  padding-left: 30px;
  background-color: #fff;
  min-height: 550px;
  .t-nav {
    nav{
      border-bottom: 2px solid #ddd;
      ul {
        height: 60px;
        color: #b4b8bb;
        li{
          float: left;
          height: 60px;
          line-height: 60px;
          font-size: 15px;
          margin-right: 65px;
          a{
            color:#b4b8bb;
          }
        }
        li.active {
          border-bottom: 2px solid #f01400;
          a{
            color:#f01400;
          }
        }
        li:hover {
          border-bottom: 2px solid #f97575;
          a{
            color:#f97575;
          }
        }
      }
    }
  }
  .search{
    padding-left: 10px;
    margin-top: 25px;
    text-align: left;
    font-size: 12px;
    margin-bottom: 10px;
    .el-date-editor{
      width: 270px;
    }
    .el-select{
      width: 160px;
      .el-input__inner{
        width: 160px;
      }
    }
    .el-input{
      width: 180px;
    }
    .el-date-editor {
      .el-icon-date{
        position: absolute;
        right: 1px;
        top: 2px;
      }
    }
    span,.el-date-editor,.el-select{
      margin-right: 10px;
    }
    span.btn-srarch{
      display: inline-block;
      padding: 0 15px;
      line-height: 32px;
      height: 32px;
      background-color: #f14242;
      margin-left: 10px;
      color: #fbdfdd;
      cursor: pointer;
      margin-right: 0px;
    }
  }
  .el-table__body{
    .download {
      color: red;
    }
  }
  .pages{
    text-align: right;
    padding-top: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/invoice/invoice.vue